import { axiosAjax } from '@app/src/config/axios';
import { hydratePaymentType } from './hydrators';
import { decodeAccessToken } from '@app/src/helpers/decodeAccessToken';
import { getSettings } from '@app/src/configuration/config.service';

export const paymentTypeService = {
  async getData(url: string, refreshToken?: string) {
    try {
      let token = refreshToken ? refreshToken : sessionStorage.getItem('accessToken');
      const serviceId = decodeAccessToken('idService');
      const { data } = await axiosAjax.get(url.replace(':id', serviceId.toString()), {
        headers: { Authorization: `Bearer ${token}` }
      });
      return hydratePaymentType(data);
    } catch (e) {
      throw e.response;
    }
  }
}

export const refreshTokenService = {
  async getData(refreshToken: string) {
    try {
      const expToken = sessionStorage.getItem('accessToken');
      const { data, headers } = await axiosAjax.post(getSettings().API_REFRESH_TOKEN, { refreshToken, expToken });
      const refreshtoken = headers.authorization;
      localStorage.setItem('refreshtoken', refreshtoken);
      if(data.code == 100){
        sessionStorage.setItem('accessToken', data.data.accessToken);
        sessionStorage.setItem('reportToken', data.data.reportToken);
        return data;
      }else{
        throw new Error(data.message);
      }
    } catch (e) {
      throw e.response.data;
    }
  }
}
